import React, { Component } from "react";
import Modal from "react-modal";
import "../../../src/styles/levelOneWelcomeModal.scss";
import "./ModalSubmitAnswer.scss";
import "../../../src/styles/modal.scss";
//import logo from "./koala-animation.gif";
import ClickableMap from "./ClickableMap";

export default class ModalSubmitAnswer extends Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: true,
      answered: false
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // to change text color in modal
    //this.subtitle.style.color = '#000000';
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  handleAnswer = () => {
    this.setState({
      answered: true
    });
    localStorage.setItem("answered", "true");
    localStorage.setItem("whichModal", "two");
  };

  reset = () => {
    localStorage.setItem("answered", "false");

    this.setState({
      answered: false
    });
  };

  componentDidMount() {
    if (localStorage.getItem("answered") === "true") {
      this.setState({
        answered: true
      });
    }
  }

  render() {
    return (
      <div>
        <Modal
          className="Modal-content"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldFocusAfterRender={false}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel="Example Modal"
        >
          <button
            className="button-close-map"
            onClick={() => {
              this.closeModal();
              this.props.readyToAnswerAgain();
            }}
            //If user has clicked the map, hide the button. Using opacity is IMPORTANT because otherwise the space for button on page isn't reserved and entire page jumps.
            style={this.state.answered ? { opacity: 0 } : { opacity: 1 }}
            disabled={this.state.answered}
          >
            <span aria-hidden="true">×</span>
          </button>

          <h4 className="Modal-head">
            Which &nbsp;
            <span style={{ color: "#52b452dc" }}>continent &nbsp;</span>are you
            at?
          </h4>

          <div>
            <p className="modal-header__subtext">
              Click on the continent on the map below that you think you are
              currently in, based on what you saw in your environment.
              <span style={{ fontWeight: 600 }}>
                {" "}
                Think closely, as you have only one guess.
              </span>
            </p>
          </div>

          <div className="think-closely-mobile">
            <center>
              <span style={{ fontWeight: 600 }}>
                Think closely, as you have only one guess.
              </span>
            </center>
          </div>

          <div />
          <div className="map">
            <center>
              <ClickableMap
                compare={this.props.compare}
                handleAnswer={this.handleAnswer}
                answered={this.state.answered}
                currentCoordinates={this.props.currentCoordinates}
              />
            </center>
          </div>

          <div>
            <div className="Mini-text-map-mobile">
              {" "}
              <center>
                <span style={{ fontWeight: 600 }}> Continent &nbsp;</span>{" "}
                <span style={{ color: "lightgrey" }}> -> &nbsp;Country </span>
              </center>
            </div>
          </div>

          <br />
          <div className="modal-content--footer">
            <h1 className="Modal-score">
              Total score
              <span style={{ color: "#52b452dc" }}>
                &nbsp; {this.props.totalScore}{" "}
              </span>
            </h1>

            <div>
              <p className="Mini-text-map">
                {" "}
                <span style={{ fontWeight: 600 }}> Continent &nbsp;</span>{" "}
                <span style={{ color: "lightgrey" }}> -> &nbsp;Country </span>
              </p>
            </div>

            <div className="modal-button--continue">
              <button
                disabled={!this.state.answered}
                className="cta-button-map"
                onClick={() => {
                  this.reset();
                  this.closeModal();
                  this.props.goToCountry();
                  this.props.changeModal();
                  this.props.readyToAnswerAgain();
                }}
              >
                {" "}
                Continue{" "}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
